export const arrRespuestasCalificadas = ({respuestas, preguntas}) => {


    let arr = []
    for (let i = 0, len = preguntas.length; i < len; i++) {

        let pregunta = preguntas[i]
        let keyRespuesta = 'respuesta' + [i]
        let respuesta = pregunta.opciones[respuestas[keyRespuesta] - 1]
        let correcta = pregunta.opciones[pregunta.correcta - 1]
        let punto = (correcta === respuesta)
        let obj = {
            pregunta: preguntas[i].pregunta,
            correcta: correcta,
            respuesta: respuesta,
            punto: punto
        }

        arr.push(obj)


    }

    return arr


}